import React from 'react';
import {
  DatePicker as AntdDatePicker,
  DatePickerProps as AntDatePickerProps,
} from 'antd';

export type DatePickerProps = Omit<AntDatePickerProps, 'picker' | 'onKeyDown'>

const DEFAULT_FORMAT = 'MM/DD/YYYY';
const SEPARATOR = '/';

const DatePicker = ({
  format,
  ...restProps
}: DatePickerProps) => {
  const realFormat = format ?? DEFAULT_FORMAT;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (realFormat !== DEFAULT_FORMAT || event.key < '0' || event.key > '9') {
      return;
    }

    const input = event.target as HTMLInputElement;
    const srcValue = input.value;
    const pos = event.currentTarget.selectionStart ?? 0;
    let newValue = srcValue.substring(0, pos) + event.key + srcValue.substring(pos);
    if (![2, 5].includes(newValue.length)) {
      return;
    }

    newValue += SEPARATOR;
    input.value = newValue;
    event.preventDefault();
  };

  return (
    <AntdDatePicker
      onKeyDown={handleKeyDown}
      picker="date"
      format={realFormat}
      {...restProps}
    />
  );
};

export default DatePicker;
